'use client';

import useSiteStore from '@/store/site.store';
import api from '@/lib/axios';
import { Toaster } from 'react-hot-toast';
import { Inter } from 'next/font/google';
import './globals.css';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import useAuthStore from '@/store/auth.store';


const inter = Inter({ subsets: ['latin'] });

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  const adminSayfasi = pathname.startsWith('/admin');
  const tamEkranSayfalar = ['/giris', '/kayit', '/sifre-sifirla-talep', '/sifre-sifirla', '/email-dogrula'];
  const tamEkran = tamEkranSayfalar.some(s => pathname.startsWith(s));

  useEffect(() => {
    useAuthStore.persist.rehydrate();
    api.get('/site-ayarlari').then((res) => {
      useSiteStore.getState().setAyarlar(res.data);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const parts = pathname.split('/').filter(Boolean);
    const slug = parts.length === 0 ? 'anasayfa' : parts[0];
    const sabitSayfalar = ['anasayfa', 'sepet', 'siparis', 'siparislerim', 'hesabim', 'giris', 'kayit', 'iletisim', 'hakkimizda'];
    if (!sabitSayfalar.includes(slug)) return;
    api.get(`/sayfalar/slug/${slug}`).then((res) => {
      if (res.data?.seo_baslik) document.title = res.data.seo_baslik;
      else document.title = 'KaracaSpor';
    }).catch(() => { document.title = 'KaracaSpor'; });
  }, [pathname]);


  return (
    <html lang="tr">
      <body className={inter.className}>
        <QueryClientProvider client={queryClient}>
          <Toaster position="top-right" />
          {!adminSayfasi && !tamEkran && <Navbar />}
          <main className={tamEkran ? '' : 'min-h-screen bg-[var(--color-gray-50)]'}>
            {children}
          </main>
          {!adminSayfasi && !tamEkran && <Footer />}
        </QueryClientProvider>
      </body>
    </html>
  );
}
